/**
 * Rivets brand mark.
 *
 * Source of truth: public/brand/logo-white.svg (svgo-optimised from the Frontier
 * brand kit). Inlined here with `currentColor` so the mark follows the active
 * theme and never flashes / round-trips over the network.
 */

export type BrandLogoProps = {
  /** Height of the mark in px. Defaults to 20. */
  size?: number;
  /** Render the "Rivets" wordmark next to the mark. */
  wordmark?: boolean;
  className?: string;
};

export function BrandMark({ size = 20, className }: { size?: number; className?: string }) {
  return (
    <svg
      viewBox="0 0 300 300"
      width={size}
      height={size}
      fill="currentColor"
      role="img"
      aria-label="Rivets"
      className={className}
      style={{ flex: "none", display: "block" }}
    >
      <path d="m154.85 184.19 44.85 106.3a148 148 0 0 1-49.71 8.54C67.73 299.03 1 232.3 1 149.97 1 124.78 7.27 101 18.33 80.23h67.89L56.73 240.35h44.67l10.38-56.16z" />
      <path d="M169.23 146.59H118.6l12.23-66.36h51.31q6.55-.01 11.98 2.09a29 29 0 0 1 9.22 5.71 27 27 0 0 1 5.96 8.73 29 29 0 0 1 2.15 11.31 35.5 35.5 0 0 1-3.38 15.42 40 40 0 0 1-9.22 12.17 41 41 0 0 1-13.46 8.05 46 46 0 0 1-16.16 2.89Z" />
      <path d="M299 149.97c0 48.36-22.98 91.3-58.62 118.46l-39.94-90.08a87 87 0 0 0 39.75-27.71 77 77 0 0 0 16.46-47.99c0-9.15-1.6-17.2-4.79-24.52a56 56 0 0 0-13.52-19.05 62 62 0 0 0-21.2-12.17c-8.17-2.89-17.45-4.3-27.4-4.3H46.71A148.3 148.3 0 0 1 150 .97c82.33 0 149 66.73 149 149" />
    </svg>
  );
}

export function BrandLogo({ size = 20, wordmark = true, className }: BrandLogoProps) {
  return (
    <span className={`brand-logo${className ? ` ${className}` : ""}`}>
      <BrandMark size={size} className="brand-logo-mark" />
      {wordmark && (
        <span className="brand-logo-word" style={{ fontSize: Math.round(size * 0.78) }}>
          Rivets
        </span>
      )}
    </span>
  );
}
